import type { mediaUpload as mediaUploadEn } from "../en/mediaUpload";

// Panel hromadného nahrávání (stránka Média a záložka Nahrát ve výběru fotek) a dialog
// odchodu během běžící dávky. Blok `leave` patří hlídání odchodu; ostatní klíče patří panelu
// (`components/media/upload/BatchUploadPanel.tsx`).
export const mediaUpload: typeof mediaUploadEn = {
  dropHint: "Přetáhněte sem fotky nebo celou složku",
  addMore: "Přidat další",
  chooseFiles: "Vybrat soubory",
  chooseFolder: "Vybrat složku",
  rejected: "Nepřidané soubory: {{count}} — nejsou to fotky.",
  countries: "Země",
  source: "Zdroj",
  sourceHint:
    "Autor nebo fotobanka; nabídka ukazuje dřívější zdroje. Existující fotce se zdroj zapíše, jen když žádný nemá.",
  sourceHintPicker: "Autor nebo fotobanka; nabídka ukazuje dřívější zdroje.",
  start_one: "Nahrát {{count}} soubor",
  start_few: "Nahrát {{count}} soubory",
  start_other: "Nahrát {{count}} souborů",
  cancel: "Zrušit",
  finish: "Hotovo",
  remove: "Odebrat {{name}}",
  resized: "zmenšeno na {{px}} px",
  inGallery: "V galerii",
  openExisting: "Otevřít fotku",
  restore: "Obnovit z koše",
  retry: "Zkusit znovu",
  retryAll: "Zkusit znovu vše chybné",
  errorGeneric: "Nahrání se nepodařilo.",
  status: {
    queued: "Čeká",
    checking: "Kontroluje",
    preparing: "Připravuje",
    uploading: "Nahrává",
    done: "Hotovo",
    duplicateLive: "Už v knihovně",
    duplicateTrash: "V koši",
    duplicateInBatch: "Stejný soubor je v dávce",
    error: "Chyba",
    errorPermanent: "Nejde nahrát",
  },
  permanent: {
    tif: "TIF otevřete v Safari, nebo převeďte na JPG",
    heic: "HEIC nad {{limit}} tento prohlížeč nezmenší: otevřete ho v Safari, nebo převeďte na JPG",
  },
  summary: {
    done: "Hotovo: {{count}}",
    existing: "Už v knihovně: {{count}}",
    errors: "Chyby: {{count}}",
  },
  leave: {
    title: "Nahrávání ještě běží",
    text: "Některé fotky se ještě nenahrály. Když teď odejdete, ty, které čekají, se nenahrají.",
    stay: "Zůstat",
    go: "Odejít",
  },
};
